export default "__VITE_ASSET__BdhHe9Y2__"